#import "../fragments/MarketingContactFields.graphql"

query MarketingContacts(
  $listId: ID!
  $search: String
  $page: Int
  $rowsPerPage: Int
) {
  marketingContacts(
    listId: $listId
    search: $search
    page: $page
    rowsPerPage: $rowsPerPage
  ) {
    nodes {
      ...MarketingContactFields
    }
    count
  }
}
